import { GAMES_CONFIG, GAME_ORIGIN } from '../config';
import { useGameFrameMessages } from '../hooks/useGameFrameMessages';
import { ModalContainer } from './ModalContainer';
import { ModalWrapper } from './ModalWrapper';
import { useKillGameOnSessionEnd } from '../hooks/useKillGameOnSessionEnd';
import { useEffect, useMemo } from 'react';
import { GPTGameNameType } from '../types';
import { useCheckGPTGameStatus } from '../../../../api/gpt/useCheckGPTGameStatus';
import { useInvalidateBonusTransactions } from 'react-easyrocket';
import { useModalContext } from 'src/hooks/useModalContext';

export const GPTGameModal = ({
  onDeposit,
  onRegistration
}: {
  onDeposit?: (params: { promocode: string }) => void;
  onRegistration?: (params: { promocode: string }) => void;
}) => {
  const { modalProps } = useModalContext<{ gameName: GPTGameNameType }>();
  const invalidateBonusesTransactions = useInvalidateBonusTransactions();
  const gameName = modalProps.gameName;
  const timestampParam = useMemo(() => `?timestamp=${Date.now()}`, []);
  const gameSrc = GAME_ORIGIN + GAMES_CONFIG[gameName].path + timestampParam;
  const gameOrientation = GAMES_CONFIG[gameName].orientation;

  const { messagesRef, isGameReady } = useGameFrameMessages({
    gameName,
    onDeposit,
    onRegistration
  });

  const { refetch } = useCheckGPTGameStatus({ gameName });
  useKillGameOnSessionEnd(gameName);

  useEffect(() => {
    /** Что делаем когда игра закрывается.
     * 1) Перепроверяем бонусные транзакции
     * 2) Перепроверяем статус доступности игры
     */
    return () => {
      invalidateBonusesTransactions();
      refetch();
    };
  }, []);

  return (
    <ModalContainer>
      <ModalWrapper orientation={gameOrientation}>
        <iframe className="z-[1] h-full w-full" ref={messagesRef} src={gameSrc} />
      </ModalWrapper>
    </ModalContainer>
  );
};
